export default __webpack_public_path__ + "static/media/double_perso.efd13e91.webp";